// @flow
const throttle = (
  fn: (args: any) => any,
  interval: number,
  callFirst: boolean,
) => {
  let wait = false;
  let callNow = false;

  return (...args: Array<any>) => {
    callNow = callFirst && !wait;

    if (!wait) {
      wait = true;
      return new Promise(resolve => {
        setTimeout(() => {
          wait = false;
          if (!callFirst) {
            // return fn.apply(context, args);
            resolve(fn(...args));
          }
        }, interval);
      });
    }

    if (callNow) {
      callNow = false;

      // @ts-ignore
      return Promise.resolve(fn(...args));
    }

    return Promise.resolve();
  };
};

export { throttle };
